import { render, staticRenderFns } from "./Web3ErrorDialog.vue?vue&type=template&id=1c62f238&scoped=true&"
import script from "./Web3ErrorDialog.vue?vue&type=script&lang=ts&"
export * from "./Web3ErrorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./Web3ErrorDialog.vue?vue&type=style&index=0&id=1c62f238&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c62f238",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QIcon,QCardActions,QBtn});
